import { cn } from "@/lib/utils";

export const GLASS_CARD =
  "rounded-2xl p-6 bg-black/5 dark:bg-black/30 backdrop-blur-md border border-white/15 dark:border-white/10 shadow-lg";

interface GlassCardProps {
  className?: string;
  children: React.ReactNode;
}

export function GlassCard({ className, children }: GlassCardProps) {
  return (
    <div className={cn(GLASS_CARD, className)}>
      {children}
    </div>
  );
}
